import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, palette, variables }) => ({
  bottomNavigationWrapper: {
    padding: `${variables?.spacingNone} ${variables?.spacingF}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingTop: '10px',
    justifyContent: 'space-between',
    height: '72px',
    backgroundColor: palette.jet?.containerDefault,
    borderTop: `1px solid ${palette.jet?.borderDefault}`,
    boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.2)',
    position: 'fixed',
    overflow: 'hide',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1,
    '&.isPWA' : {
      height:'72px'
    }
  },
  bottomNavigationItems: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    color: palette.jet?.containerDark,
    webkitTapHighlightColor: palette.secondary.main,
    '&:hover': {
      cursor: 'pointer',
      color: palette.jet?.contentBrand,
      '& .bottomNavigationIconColor': {
        '& g': {
          fill: palette.jet?.contentBrand,
        },
        '& path': {
          fill: palette.jet?.contentBrand,
        },
      },
    },
    '&.active': {
      color: palette.jet?.contentBrand,
      '& .bottomNavigationIconColor': {
        '& g': {
          fill: palette.jet?.contentBrand,
        },
        '& path': {
          fill: palette.jet?.contentBrand,
        },
      },
    },
  },
  '& .bottomNavigationIconColor': {
    '& g': {
      fill: palette.jet?.containerDark,
    },
    '& path': {
      fill: palette.jet?.containerDark,
    },
  },
}));

export default styles;
